<template>
    <div>
        <Notification/>
    </div>
</template>
<script>
import Notification from '@/components/notifications/Notification.vue'
export default {
    name: 'IndexView',
    components: {
        Notification
    },
}
</script>
<style scoped>
</style>
